import { AudioManager } from '../../core/AudioManager';
import { AudioHandle, PositionalOptions } from '../../core/AudioManager.types';
import { Car } from '../Car';

export class SkidAudio {
    static readonly PRELOAD = ['../assets/sounds/motor_skid.wav'] as const;
    private static readonly SRC = SkidAudio.PRELOAD[0];
    private static readonly OPTIONS: PositionalOptions = { volume: 1, loop: true, refDistance: 10 };

    private handle: AudioHandle | null = null;

    constructor(
        private readonly audioManager: AudioManager,
        private readonly car: Car,
    ) {}

    public play(): void {
        if (this.handle) { return; }
        this.handle = this.audioManager.playPositional(SkidAudio.SRC, this.car, SkidAudio.OPTIONS);
    }

    public stop(): void {
        if (!this.handle) { return; }
        this.audioManager.stopPositional(this.handle);
        this.handle = null;
    }
}
